import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { SignInButton, useClerk, useUser } from "@clerk/clerk-react";

const J = {
  surface: "#111827",
  border: "0.5px solid #294766",
  muted: "#a3d1ff",
  accent: "#66b2ff",
};

const navItems = ["Features", "Testimonials", "Highlights", "Pricing", "FAQ", "Blog"];

/**
 * Mobile drawer for AppBar navigation.
 * @param {boolean} open - Drawer open state
 * @param {function} onClose - Called when drawer should close
 */
export default function AppBarDrawer({ open, onClose }) {
  const { signOut } = useClerk();
  const { isSignedIn } = useUser();

  return (
    <Drawer anchor="top" open={open} onClose={onClose}>
      <Box sx={{ p: 2, bgcolor: J.surface }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={onClose} sx={{ color: J.muted }}>
            <CloseRoundedIcon />
          </IconButton>
        </Box>

        {navItems.map((item) => (
          <MenuItem key={item} sx={{ color: J.muted }}>
            {item}
          </MenuItem>
        ))}

        <Divider sx={{ my: 2, borderColor: "#294766" }} />

        {isSignedIn ? (
          <MenuItem>
            <Button
              onClick={() => signOut()}
              fullWidth
              sx={{ color: J.accent, border: J.border }}
            >
              Sign out
            </Button>
          </MenuItem>
        ) : (
          <MenuItem>
            <SignInButton>
              <Button fullWidth sx={{ color: J.muted, border: J.border }}>
                Sign in
              </Button>
            </SignInButton>
          </MenuItem>
        )}
      </Box>
    </Drawer>
  );
}
